<template>
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.9166 2.08084L17.9191 0.0833359L9.99992 8.0025L2.08075 0.0833359L0.083252 2.08084L8.00242 10L0.083252 17.9192L2.08075 19.9167L9.99992 11.9975L17.9191 19.9167L19.9166 17.9192L11.9974 10L19.9166 2.08084Z"
    />
  </svg>
</template>
